module.exports = __webpack_public_path__ + "media/images/icons/tree-evergreen-1706d461c46be256bf4ab10a6e36d9d4.svg";